import Text from "../../Text";
import { ROUTE_PATHS } from "../../../../../constants/routeConstants";

const CategoriesMegaMenu = ({ visible, categories = [] }) => {
  const cols = categories.slice(0, 4);
  const gridClass =
    ["", "grid-cols-1", "grid-cols-2", "grid-cols-3", "grid-cols-4"][
      cols.length
    ] ?? "grid-cols-4";

  if (!cols.length) return null;

  return (
    <div className={visible ? "block" : "hidden"}>
      <div className="max-w-[1440px] mx-auto px-8 py-10">
        <div className={`grid gap-8 ${gridClass}`}>
          {cols.map((cat) => (
            <div key={cat.slug}>
              <Text
                is="a"
                href={ROUTE_PATHS.CATEGORY_DETAIL.replace(
                  ":categorySlug",
                  cat.slug,
                )}
                className="block text-sm font-semibold text-gray-900 hover:text-blue-500 transition-colors mb-3 pb-2 border-b border-gray-100"
              >
                {cat.name}
              </Text>
              <ul className="space-y-2">
                {(cat.sub_categories ?? []).slice(0, 4).map((sub) => (
                  <li key={sub.slug}>
                    <Text
                      is="a"
                      href={ROUTE_PATHS.PRODUCTS_BY_SUBCATEGORY.replace(":categorySlug", cat.slug).replace(":subCategorySlug", sub.slug)}
                      className="text-sm text-gray-500 hover:text-blue-500 transition-colors"
                    >
                      {sub.name}
                    </Text>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-6 pt-4 border-t border-gray-100">
          <Text
            is="a"
            href={ROUTE_PATHS.CATEGORIES}
            className="w-fit text-xs font-semibold text-white bg-blue-500 hover:bg-blue-600 transition-colors px-4 py-2 rounded-full"
          >
            All Categories →
          </Text>
        </div>
      </div>
    </div>
  );
};

export default CategoriesMegaMenu;
